<ng-container *ngIf="layoutTranslations$ | async as layoutTranslations">
  <ng-container *ngIf="paymentTranslations$ | async as paymentTranslations">
    <ng-container *ngIf="licenseResult$ | async as licenseResult">
      <ng-container *ngIf="licenseResult.IsLoggedIn; else notLoggedIn">
        <ng-container *ngIf="!licenseResult.UserIsLicensed">
          <ng-container *ngIf="!licenseResult.IsAdmin">
            <a
              *ngIf="buttonModel?.IsHeroButton"
              href="javascript:void(0)"
              class="btn btn-block btn-hero btn-iconed btn-iconed-anthrazit-08-primary btn-iconed-left"
              [ngClass]="buttonModel.AdditionalButtonCss || ''"
            >
              <span *ngIf="buttonModel?.PaymentType === paymentTypes.Credits">{{
                paymentTranslations['BuyCredits']
              }}</span>
              <span
                *ngIf="buttonModel?.PaymentType === paymentTypes.Subscription"
                >{{ paymentTranslations['BuySubscription'] }}</span
              >
              <i aria-hidden="true" class="btn-icon ifc-custom ifc-lock"></i>
              <i
                aria-hidden="true"
                class="ml-auto ifc-custom ifc-arrow-right"
              ></i>
            </a>
            <a
              *ngIf="!buttonModel?.IsHeroButton"
              href="javascript:void(0)"
              class="btn btn-iconed btn-iconed-primary btn-iconed-left"
              [ngClass]="buttonModel.AdditionalButtonCss || ''"
            >
              <span *ngIf="buttonModel?.PaymentType === paymentTypes.Credits">{{
                paymentTranslations['BuyCredits']
              }}</span>
              <span
                *ngIf="buttonModel?.PaymentType === paymentTypes.Subscription"
                >{{ paymentTranslations['BuySubscription'] }}</span
              >
              <i class="btn-icon ifc-custom ifc-lock" aria-hidden="true"></i
            ></a>
            <p>
              {{
                licenseResult.SubscriptionRequired
                  ? layoutTranslations['PleaseContactYourAdminToBuyALicense']
                  : layoutTranslations['PleaseContactYourAdminToBuyCredits']
              }}
            </p>
          </ng-container>
          <ng-container *ngIf="licenseResult.IsAdmin">
            <ng-container *ngIf="buttonModel?.IsPaymentDetailView">
              <ng-container
                *ngIf="buttonModel?.PaymentType === paymentTypes.Credits"
              >
                <a
                  [href]="routeLanguage + '/Account/Credits/Buy'"
                  [ngClass]="buttonModel.AdditionalButtonCss || ''"
                  >{{ paymentTranslations['BuyCredits'] }}</a
                >
              </ng-container>
              <ng-container
                *ngIf="buttonModel?.PaymentType === paymentTypes.Subscription"
              >
                <a
                  [href]="routeLanguage + '/Account/Subscriptions'"
                  [ngClass]="buttonModel.AdditionalButtonCss || ''"
                  >{{ paymentTranslations['BuySubscription'] }}</a
                >
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!buttonModel?.IsPaymentDetailView">
              <ng-container *ngIf="buttonModel?.IsHeroButton">
                <button
                  type="button"
                  (click)="showRequiredLicenseModal = true"
                  class="btn btn-block btn-hero btn-iconed btn-iconed-anthrazit-08-primary btn-iconed-left"
                  [ngClass]="buttonModel.AdditionalButtonCss || ''"
                >
                  {{ title }}
                  <i
                    aria-hidden="true"
                    class="btn-icon ifc-custom ifc-lock"
                  ></i>
                  <i
                    aria-hidden="true"
                    class="ml-auto ifc-custom ifc-arrow-right"
                  ></i>
                </button>
              </ng-container>
              <ng-container *ngIf="!buttonModel?.IsHeroButton">
                <button
                  type="button"
                  (click)="showRequiredLicenseModal = true"
                  class="btn btn-iconed btn-iconed-primary btn-iconed-left"
                  [ngClass]="buttonModel.AdditionalButtonCss || ''"
                >
                  {{ title }}&nbsp;<i
                    class="btn-icon ifc-custom ifc-lock"
                    aria-hidden="true"
                  ></i>
                </button>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="licenseResult.UserIsLicensed">
          <ng-container
            *ngIf="
              buttonModel.ShowCreditsModal &&
                !licenseResult.UserHasSubscription &&
                licenseResult.CreditsRequired;
              else loggedInAuthorized
            "
          >
            <ng-container *ngIf="buttonModel?.IsHeroButton">
              <button
                type="button"
                (click)="showCreditsModal = true"
                class="btn btn-block btn-hero btn-iconed btn-iconed-anthrazit-08-primary btn-iconed-left"
                [ngClass]="buttonModel.AdditionalButtonCss || ''"
              >
                {{ title }}
                <i
                  *ngIf="buttonModel?.ButtonIcon"
                  class="btn-icon"
                  [ngClass]="buttonModel.ButtonIcon || ''"
                  aria-hidden="true"
                ></i>
                <i
                  aria-hidden="true"
                  class="ml-auto ifc-custom ifc-arrow-right"
                ></i>
              </button>
            </ng-container>
            <ng-container *ngIf="!buttonModel?.IsHeroButton">
              <button
                type="button"
                (click)="showCreditsModal = true"
                class="btn btn-iconed btn-iconed-primary"
                [class.btn-block]="buttonModel.FullWidth"
                [ngClass]="buttonModel.AdditionalButtonCss || ''"
              >
                {{ title }}&nbsp;<i
                  *ngIf="buttonModel?.ButtonIcon"
                  class="btn-icon"
                  [ngClass]="buttonModel.ButtonIcon || ''"
                  aria-hidden="true"
                ></i>
                <i
                  *ngIf="!buttonModel?.ButtonIcon"
                  aria-hidden="true"
                  class="btn-icon ifc-custom ifc-arrow-right"
                ></i>
              </button>
            </ng-container>
          </ng-container>
          <ng-template #loggedInAuthorized>
            <ng-container
              *ngIf="
                !buttonModel.ShowCreditsModal &&
                  !licenseResult.UserHasSubscription &&
                  !licenseResult.CreditsRequired;
                else buy
              "
            >
              <ng-container *ngIf="buttonModel?.IsHeroButton">
                <button
                  type="button"
                  (click)="callback()"
                  class="btn btn-block btn-hero btn-iconed btn-iconed-anthrazit-08-primary btn-iconed-left"
                  [ngClass]="buttonModel.AdditionalButtonCss || ''"
                >
                  {{ title }}
                  <i
                    *ngIf="buttonModel?.ButtonIcon"
                    class="btn-icon"
                    [ngClass]="buttonModel.ButtonIcon || ''"
                    aria-hidden="true"
                  ></i>
                  <i
                    aria-hidden="true"
                    class="ml-auto ifc-custom ifc-arrow-right"
                  ></i>
                </button>
              </ng-container>
              <ng-container *ngIf="!buttonModel?.IsHeroButton">
                <button
                  type="button"
                  (click)="callback()"
                  class="btn btn-iconed btn-iconed-primary"
                  [class.btn-block]="buttonModel.FullWidth"
                  [ngClass]="buttonModel.AdditionalButtonCss || ''"
                >
                  {{ title }}&nbsp;<i
                    *ngIf="buttonModel?.ButtonIcon"
                    class="btn-icon"
                    [ngClass]="buttonModel.ButtonIcon || ''"
                    aria-hidden="true"
                  ></i>
                  <i
                    *ngIf="!buttonModel?.ButtonIcon"
                    aria-hidden="true"
                    class="btn-icon ifc-custom ifc-arrow-right"
                  ></i>
                </button>
              </ng-container>
            </ng-container>
          </ng-template>

          <ng-template #buy>
            <ng-container *ngIf="buttonModel?.IsHeroButton">
              <button
                type="button"
                (click)="callback()"
                class="btn btn-block btn-hero btn-iconed btn-iconed-anthrazit-08-primary btn-iconed-left"
                [ngClass]="buttonModel.AdditionalButtonCss || ''"
              >
                {{ title }}
                <i
                  *ngIf="buttonModel?.ButtonIcon"
                  class="btn-icon"
                  [ngClass]="buttonModel.ButtonIcon || ''"
                  aria-hidden="true"
                ></i>
                <i
                  aria-hidden="true"
                  class="btn-icon ml-auto ifc-custom ifc-arrow-right"
                ></i>
              </button>
            </ng-container>
            <ng-container *ngIf="!buttonModel?.IsHeroButton">
              <button
                type="button"
                (click)="callback()"
                class="btn btn-iconed btn-iconed-primary"
                [class.btn-block]="buttonModel.FullWidth"
                [ngClass]="buttonModel.AdditionalButtonCss || ''"
              >
                {{ title }}&nbsp;<i
                  *ngIf="buttonModel?.ButtonIcon"
                  class="btn-icon"
                  [ngClass]="buttonModel.ButtonIcon || ''"
                  aria-hidden="true"
                ></i>
                <i
                  *ngIf="!buttonModel?.ButtonIcon"
                  aria-hidden="true"
                  class="btn-icon ifc-custom ifc-arrow-right"
                ></i>
              </button>
            </ng-container>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-template #notLoggedIn>
        <button
          type="button"
          (click)="showLoginModal = true"
          class="btn btn-iconed btn-iconed-primary btn-iconed-left"
          [ngClass]="buttonModel.AdditionalButtonCss || ''"
        >
          {{ paymentTranslations['Login'] }}&nbsp;<i
            class="btn-icon ifc-custom ifc-lock"
            aria-hidden="true"
          ></i>
        </button>
      </ng-template>

      <hazmatsuite-next-modal
        [title]="layoutTranslations['ModalRestrictedAccessTitle']"
        [cancelButtonLabel]="layoutTranslations['ButtonCancel']"
        [showModal]="showLoginModal"
        [hideButtons]="true"
        modalSize="md"
        (closeModal)="showLoginModal = false"
      >
        <p>
          {{ layoutTranslations['ModalRestrictedAccessTextNew'] }}&nbsp;
          <a [href]="registerUrl" (click)="beforeNavigationAction.emit()">{{
            layoutTranslations['ModalRestrictedAccessTextNewRegister']
          }}</a>
        </p>
        <div class="row">
          <div class="col-md-6">
            <button
              (click)="showLoginModal = false"
              (click)="beforeNavigationAction.emit()"
              class="btn btn-iconed btn-iconed-left btn-iconed-default-white w-auto"
            >
              {{ layoutTranslations['ModalButtonClose'] }}&nbsp;<i
                class="btn-icon ifc-custom ifc-close"
              ></i>
            </button>
          </div>
          <div class="col-md-6">
            <a
              [href]="loginUrl"
              (click)="beforeNavigationAction.emit()"
              class="btn btn-iconed btn-iconed-primary w-auto float-right"
              aria-label="Ok"
              >{{ layoutTranslations['HeaderMenuLogin'] }}&nbsp;<i
                class="btn-icon ifc-custom ifc-arrow-right"
              ></i
            ></a>
          </div>
        </div>
      </hazmatsuite-next-modal>

      <hazmatsuite-next-modal
        [title]="
          layoutTranslations['ModalRestrictedAccessLicenseRequiredTitle']
        "
        [cancelButtonLabel]="layoutTranslations['ButtonCancel']"
        [showModal]="showRequiredLicenseModal"
        modalSize="md"
        (closeModal)="showRequiredLicenseModal = false"
      >
        <p id="restrictedAccessLicenseRequiredModalContent">
          {{ layoutTranslations['ModalRestrictedAccessLicenseRequiredText']
          }}<br />
          {{ layoutTranslations['ModalRestrictedAccessGetLicenseFromAccount'] }}
        </p>
        <p
          id="restrictedAccessCreditsRequiredModalContent"
          *ngIf="licenseResult.CreditsRequired"
        >
          {{
            layoutTranslations['ModalRestrictedAccessCreditsRequiredText']
              | stringReplace: licenseResult.RequiredCredits.toString()
          }}
          <a
            [href]="routeLanguage + '/Account/Credits'"
            (click)="beforeNavigationAction.emit()"
            >{{ layoutTranslations['Here'] }}</a
          >
        </p>
      </hazmatsuite-next-modal>

      <hazmatsuite-next-modal
        [title]="layoutTranslations['ModalCreditCostsTitle']"
        [showModal]="showCreditsModal"
        [hideButtons]="true"
        modalSize="lg"
        (closeModal)="showCreditsModal = false"
      >
        <p
          *ngIf="licenseResult.CreditsRequired"
          [innerHtml]="
            layoutTranslations['ThisActionCostsCredits']
              | stringReplace: licenseResult.RequiredCredits.toString()
              | safeHtml
          "
        ></p>
        <p *ngIf="licenseResult.SubscriptionRequired">
          {{
            layoutTranslations['ThisActionCostsCreditsLicenseHint']
              | stringReplace: buttonModel.Toolname
          }}
          &nbsp;
          <a [href]="subscriptionUrl">{{ layoutTranslations['Here'] }}</a>
        </p>
        <div class="row">
          <div class="col-md-6">
            <button
              class="btn btn-iconed btn-iconed-left btn-iconed-default-white w-auto"
              aria-label="Cancel"
              (click)="showCreditsModal = false"
            >
              {{ layoutTranslations['ModalButtonClose'] }}
              <i class="btn-icon ifc-custom ifc-close"></i>
            </button>
          </div>
          <div class="col-md-6">
            <button
              (click)="callback()"
              class="btn btn-iconed btn-iconed-primary w-auto float-right"
              aria-label="Ok"
            >
              {{ layoutTranslations['ContinueChargeable'] }}
              <i class="btn-icon ifc-custom ifc-arrow-right"></i>
            </button>
          </div>
        </div>
      </hazmatsuite-next-modal>
    </ng-container>
  </ng-container>
</ng-container>
